export default __webpack_public_path__ + "assets/landing_page_obj.b714e728353124706bff2e4eb7d148de.svg";